function onConsent(preference) {
    console.log('onConsent', preference);
    eraseCookie('cookie_law_accepted');
    eraseCookie('cookie_law_accepted_1');
    eraseCookie('cookie_law_accepted_2');
    eraseCookie('cookie_law_accepted_3');
    eraseCookie('cookie_law_accepted_4');
    eraseCookie('cookie_law_accepted_5');

    setTimeout(function () {
        if (preference.consent) {
            dataLayer.push({'event': 'cookie_law_accepted'});
            setCookie('cookie_law_accepted', 1, 366);
            dataLayer.push({'event': 'cookie_law_accepted_1'});
            setCookie('cookie_law_accepted_1', 1, 366);
            dataLayer.push({'event': 'cookie_law_accepted_2'});
            setCookie('cookie_law_accepted_2', 1, 366);
            dataLayer.push({'event': 'cookie_law_accepted_3'});
            setCookie('cookie_law_accepted_3', 1, 366);
            dataLayer.push({'event': 'cookie_law_accepted_4'});
            setCookie('cookie_law_accepted_4', 1, 366);
            dataLayer.push({'event': 'cookie_law_accepted_5'});
            setCookie('cookie_law_accepted_5', 1, 366);
        } else if (preference.purposes) {
            if (preference.purposes[1]) {
                dataLayer.push({'event': 'cookie_law_accepted_1'});
                setCookie('cookie_law_accepted_1', 1, 366);
            }
            if (preference.purposes[2]) {
                dataLayer.push({'event': 'cookie_law_accepted_2'});
                setCookie('cookie_law_accepted_2', 1, 366);
            }
            if (preference.purposes[3]) {
                dataLayer.push({'event': 'cookie_law_accepted_3'});
                setCookie('cookie_law_accepted_3', 1, 366);
            }
            if (preference.purposes[4]) {
                dataLayer.push({'event': 'cookie_law_accepted_4'});
                setCookie('cookie_law_accepted_4', 1, 366);
            }
            if (preference.purposes[5]) {
                dataLayer.push({'event': 'cookie_law_accepted_5'});
                setCookie('cookie_law_accepted_5', 1, 366);
            }
        }
    }, 500);
}

var _iub = _iub || [];
_iub.csConfiguration = {
    "ccpaApplies": true,
    "whitelabel": false,
    "enableUspr":true,
    "enableCcpa": true,
    "lang": iubenda__locale,
    "floatingPreferencesButtonDisplay": "bottom-left",
    "siteId": iubenda__siteId,
    "consentOnContinuedBrowsing": false,
    "perPurposeConsent": true,
    "cookiePolicyId": iubenda__cookiePolicyId,
    "callback": {
        "onPreferenceFirstExpressed": function(event) {
            onConsent(event);
        }
    },
    "banner": {
        "acceptButtonDisplay": true,
        "acceptButtonColor":"#e10e21",
        "rejectButtonDisplay":true,
        "rejectButtonColor":"#4c4c4c",
        "customizeButtonDisplay": true,
        "position": "float-center"
    },
};